import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant';
import router from './router';

import 'vant/lib/index.css';



// import { ConfigProvider } from 'vant';

const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
  console.error('Vue error 全局异常捕获:', err, info)
  router.push('/wrong') // 跳转到 error 页面
}



app.use(Vant);
app.use(router);

// app.use(ConfigProvider);



app.mount('#app');
